"use strict";

module.exports = function () {
  if (typeof localStorage === 'undefined') return {};
  return this.opts.storage === 'local' ? localStorage : sessionStorage;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/computed/storage.js
// module id = 1564
// module chunks = 64